import $ from 'jquery';

/**
 * # Funktionsweise
 * Eine Accordion-Liste wird dargestellt, wie eine Liste. Die einzelnen Elemente der Liste werden zunächst in einer
 * vereinfachten Darstellung angezeigt. Wenn man dann einen Link in dieser vereinfachten Darstellung aktiviert, wird
 * das Element erweitert und zeigt mehr Details an. Dieser Link sollte auch keinen Seitenwechsel auslösen. Wenn ein
 * Link der vereinfachten Darstellung eines anderen Elements aktiviert, so wird das bislang erweitere Element wieder
 * zusammengeklappt und das neu aktivierte Element wird erweitert.
 * Ein erweitertes Element kann dann auch Link-Elemente enthalten, die einen Seitenwechsel auslösen können.
 *
 * # Einsatz
 * Diese Komponente kommt beispielsweise bei der Zahl- und Versandartübersicht zum Einsatz.
 */
export default function (mountpoint) {
	let elem = $(mountpoint);
	let items = elem.find('.element--accordion-list--item');

	items.addClass('item-hidden').first().removeClass('item-hidden');

	elem.find('.element--accordion-list--activator').click(function () {
		let elem = $(this);
		elem.closest('.element--accordion-list').find('.element--accordion-list--item').addClass('item-hidden');
		elem.closest('.element--accordion-list--section').find('.element--accordion-list--item').removeClass('item-hidden');
	});

	items.each(function(k, item) {
		item = $(item);

		let itemAction = item.find('.element--accordion-list--item-action');
		let desc = item.find('.description');

		/* set target="_blank" and stopPropagation for each anchor in the description */
		desc.find('a').each(function(k, descLink) {
			descLink = $(descLink);
			descLink.attr('target', '_blank');

			descLink.on('click', function(e) {
				e.stopPropagation();
			})
		});

		/* make whole description clickable */
		desc.click(function(e) {
			itemAction.get(0).click();
		});
	});
}
